import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import {
  DataGranularity,
  DeviceType,
  FilterType,
  OrderSourceType,
  PointSeriesValue,
  TopItemData,
} from '@/api/dashboard'
import { SKUItem } from '@/api/types'
import { createTopItemsData } from '@/layouts/dashboard/demo_data/createSankeyData'

type Query = {
  /**
   * Tz
   * @default 0
   */
  tz?: number

  type?: FilterType

  limit?: number

  start_at?: number

  end_at?: number

  granularity?: DataGranularity

  device_type?: DeviceType

  order_source?: OrderSourceType

  countries?: string
}

export const useTopSkuItemQuery = (
  companyId: string,
  gameId: string,
  query: Query = {},
  enabled = true,
  demoSelectedFilter = '7',
) => {
  return useQuery({
    queryKey: ['top-items', gameId, query, gameId == import.meta.env.VITE_DEMO_GAME_ID ? demoSelectedFilter : ''],
    queryFn: ({ signal }) => {
      if (gameId == import.meta.env.VITE_DEMO_GAME_ID) {
        return dashboardClient.v1.getItems({ companyId, gameId, limit: 5 }).then(r => {
          const items = r.data as SKUItem[]
          return { data: createTopItemsData(items, demoSelectedFilter) }
        })
      }
      return dashboardClient.v1.getTopItems({ companyId, gameId, ...query }, { signal })
    },
    select: response => {
      let data = response.data
      if (!data.length) {
        return data
      }

      const oldDataFormat = data as unknown as PointSeriesValue[]
      if (oldDataFormat[0].category) {
        // Convert old data (from old backend) format to new format
        return oldDataFormat.map(item => ({
          name: item.category || '',
          sku: item.category,
          sales: item.values['sales'] || 0,
          count_sales: item.values['count_sales'] || 0,
          id: item.category || '',
        })) as TopItemData[]
      }

      return data
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    refetchOnMount: false,
    enabled: enabled,
  })
}
